"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUnarchiveTeamByIdMutation = exports.useArchiveTeamByIdMutation = exports.useCreateTeamMutation = exports.useGetTeamAdminsQuery = exports.useGetTeamMembersQuery = exports.useGetTeamSettingsQuery = exports.useGetTeamListQuery = exports.useGetTeamsQuery = exports.teamMembersAdapter = exports.teamListAdapter = exports.teamsAdapter = void 0;

var _toolkit = require("@reduxjs/toolkit");

var _utils = require("@alycecom/utils");

var _EmptyAppApi = require("../EmptyAppApi");

var _billing = require("../billing/billing");

var _types = require("./types");

var teamsAdapter = (0, _toolkit.createEntityAdapter)();
exports.teamsAdapter = teamsAdapter;
var teamListAdapter = (0, _toolkit.createEntityAdapter)();
exports.teamListAdapter = teamListAdapter;
var teamMembersAdapter = (0, _toolkit.createEntityAdapter)();
exports.teamMembersAdapter = teamMembersAdapter;

var teams = _EmptyAppApi.emptyAppApi.enhanceEndpoints({
  addTagTypes: [_billing.BillingApiTag.BillingHierarchy]
}).injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getTeams: build.query({
        query: function query() {
          return '/api/v1/teams';
        },
        transformResponse: function transformResponse(response) {
          return teamsAdapter.addMany(teamsAdapter.getInitialState(), response.data);
        }
      }),
      getTeamList: build.query({
        query: function query(params) {
          return "/api/v1/team-list?".concat((0, _utils.queryParamsBuilder)(params || {
            admin: _types.TeamListAdminOptions.AllTeams
          }));
        },
        transformResponse: function transformResponse(response) {
          return teamListAdapter.addMany(teamListAdapter.getInitialState(), response.data);
        }
      }),
      getTeamSettings: build.query({
        query: function query(_ref) {
          var teamId = _ref.teamId;
          return "/api/v1/teams/".concat(teamId, "/settings");
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      }),
      getTeamMembers: build.query({
        query: function query(_ref2) {
          var teamId = _ref2.teamId;
          return "/api/v1/teams/".concat(teamId, "/members");
        },
        transformResponse: function transformResponse(response) {
          return teamMembersAdapter.addMany(teamMembersAdapter.getInitialState(), response.data);
        }
      }),
      getTeamAdmins: build.query({
        query: function query(_ref3) {
          var teamId = _ref3.teamId;
          return "/api/v1/teams/".concat(teamId, "/admins");
        },
        transformResponse: function transformResponse(response) {
          return teamMembersAdapter.addMany(teamMembersAdapter.getInitialState(), response.data);
        }
      }),
      createTeam: build.mutation({
        query: function query(body) {
          return {
            url: '/api/v1/teams',
            method: 'POST',
            body: body
          };
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      }),
      archiveTeamById: build.mutation({
        query: function query(teamId) {
          return {
            url: "/api/v1/teams/".concat(teamId, "/archive"),
            method: 'POST'
          };
        },
        invalidatesTags: [{
          type: _billing.BillingApiTag.BillingHierarchy
        }]
      }),
      unarchiveTeamById: build.mutation({
        query: function query(teamId) {
          return {
            url: "/api/v1/teams/".concat(teamId, "/unarchive"),
            method: 'POST'
          };
        },
        invalidatesTags: [{
          type: _billing.BillingApiTag.BillingHierarchy
        }]
      })
    };
  }
});

var useGetTeamsQuery = teams.useGetTeamsQuery,
    useGetTeamListQuery = teams.useGetTeamListQuery,
    useGetTeamSettingsQuery = teams.useGetTeamSettingsQuery,
    useGetTeamMembersQuery = teams.useGetTeamMembersQuery,
    useGetTeamAdminsQuery = teams.useGetTeamAdminsQuery,
    useCreateTeamMutation = teams.useCreateTeamMutation,
    useArchiveTeamByIdMutation = teams.useArchiveTeamByIdMutation,
    useUnarchiveTeamByIdMutation = teams.useUnarchiveTeamByIdMutation;
exports.useUnarchiveTeamByIdMutation = useUnarchiveTeamByIdMutation;
exports.useArchiveTeamByIdMutation = useArchiveTeamByIdMutation;
exports.useCreateTeamMutation = useCreateTeamMutation;
exports.useGetTeamAdminsQuery = useGetTeamAdminsQuery;
exports.useGetTeamMembersQuery = useGetTeamMembersQuery;
exports.useGetTeamSettingsQuery = useGetTeamSettingsQuery;
exports.useGetTeamListQuery = useGetTeamListQuery;
exports.useGetTeamsQuery = useGetTeamsQuery;